import { ContractFeeChargeOne } from '@Common/types/bo/b2b/contract_fee_charges';

export const b2bContractFeeChargesTranslations = {
  sections: {
    details: 'Details',
    paid_by: 'Who is paying the fee?',
    information: 'Information',
    total_fee: 'Total fee amount',
    confirmation: {
      summary: 'Fee summary and confirmation',
      paid_by: 'To be paid by',
      company_name: 'Company name',
      contract_number: 'Contract number',
      fee_type: 'Fee type',
      amount: 'Amount',
    },
  },
  steps: {
    general_details: 'General details',
    confirmation: 'Confirmation',
  },
  actions: {
    create: {
      success: 'Fee created',
      failure: 'Failed to create fee: %{error}',
      title: 'Create fee',
    },
  },
  hints: {
    pereco_custody:
      'Enter the computed amount: %{rate}% of PERECO assets, capped at €%{max}. Prefill from an employee is not available yet.',
  },
  paid_by_values: {
    company: 'Company',
    user: 'Employee',
  } satisfies Record<ContractFeeChargeOne['paid_by'], string>,
  fee_label: {
    company_file_opening: 'File opening fees',
    affiliate_account_closure: 'Account closure capping fee',
    affiliate_account_position_at_given_date: 'Position editing (excluding inheritance)',
    affiliate_collective_operation_by_cheque:
      'Payment of a profit-sharing, incentive or value-sharing bonus by cheque for immediate collection',
    affiliate_annual_custody_for_former_or_retired_employees: 'Account management fees',
    affiliate_annual_custody_for_former_or_retired_employees_pereco:
      'PERECO account management fees',
    affiliate_undelivered_mail_handling: 'Fee for A/R letter sent to invalid address',
    affiliate_direct_debit_rejection: 'Unpaid cheque or direct debit charges',
    affiliate_estate_settlement_high_amount: 'Early redemption for inheritance >€5000',
    affiliate_estate_settlement_low_amount: 'Early redemption for inheritance €500-5000',
    affiliate_pledging_or_release_of_assets: 'Pledging or release of savings',
    affiliate_reissue_bank_transfer: 'Reissue of a transfer in France',
    affiliate_repayment_by_cheque: 'Redemption by cheque',
    affiliate_specific_mail_requests_processing: 'Specific treatments',
    affiliate_reissue_cheque: 'Reissue of a cheque',
    affiliate_repayment_of_savings:
      'Buyback operation (early release, available, retirement) requested by mail',
    affiliate_repayment_reimbursement_triggered:
      'Buyback with trigger condition, requested by mail',
    affiliate_retractation_following_pereco_payment: 'Withdrawal PERECO payment',
    affiliate_search_for_documents_or_transactions_after_10_years:
      'Operation search costs over 10 years',
    affiliate_search_for_documents_or_transactions_before_10_years:
      'Operation search costs less than 10 years',
    affiliate_statements_and_certificates: 'Printing of statements and certificates',
    affiliate_transfer_from_pee_to_another_manager:
      'Invoicing of losing individual transfers (flat rate)',
    affiliate_transfer_from_pereco_to_another_manager_pct:
      'Invoicing of individual loss-making transfers to PERECO (1%)',
    affiliate_voluntary_payment_by_cheque: 'Voluntary cheque payment rates',
    company_calculating_individual_allocations_particip:
      'Co-payment calculation Participation excl.',
    company_calculating_individual_allocations_profit:
      'Calculation of profit-sharing quota excluding VAT',
    company_ccb_annual_fee: 'Annual CCB fee excl.',
    company_ccb_fee_per_account: 'CCB rate per individual account excl.',
    company_collective_transfer_to_another_manager:
      'Collective transfer fee excl. VAT (max 1,000 eur)',
    company_fee_per_account: 'PEE/PERCO (or PERECO) rate per individual account, excluding VAT',
    company_integration_of_affiliates_choices_via_mail_particip:
      'Return by mail option notice Participation excl.',
    company_integration_of_affiliates_choices_via_mail_profit:
      'Return of option notice by mail Profit-sharing excluding VAT',
    company_integration_of_affiliates_choices_via_mail_value:
      'Return by mail option notice Value-sharing premium excl. tax',
    company_integration_of_affiliates_consultation_data_particip: 'Integration of non-web files',
    company_integration_of_affiliates_consultation_data_profit: 'Integration of non-web files',
    company_integration_of_affiliates_consultation_data_value:
      'Integration of files outside the WEB Value-sharing bonus excl.',
    company_integration_of_affiliates_data: 'Integration of files outside WEB Affiliation HT',
    company_other: 'Miscellaneous special services',
    company_pee_fee_per_account: 'PEE rate per individual account excl.',
    company_pee_pereco_annual_fee: 'PERCO/PERECO annual fee excl.',
    company_pereco_fee_per_account: 'PERCO (or PERECO) rate per individual account, excluding VAT',
    company_publishing: 'Desktop publishing services (employee statements, etc.) excluding VAT',
    company_rejection_of_direct_debit_or_bank_transfer: 'Rejected direct debit or bank transfer',
    company_soles_annual_fee_tc: 'Total annual fee excl.',
    company_soles_annual_reduced_fee_tc: 'Total reduced annual fee excl.',
    company_soles_fee_tc_per_affilliate: 'Soles rate per beneficiary excl.',
    company_soles_reduced_fee_tc_per_affilliate: 'Reduced Soles rate per beneficiary excl.',
  } satisfies Record<ContractFeeChargeOne['fee_label'], string>,
  fields: {
    id: 'Fee ID',
    paid_by: 'Paid by',
    b2b_contract_id: 'Contract ID',
    b2b_company_id: 'Company ID',
    b2b_contract_version_num: 'Contract version',
    fee_label: 'Label',
    amount: 'Amount',
    updated_at: 'Updated at',
    created_at: 'Created at',
  } satisfies Record<keyof ContractFeeChargeOne, string>,
};
